import { OpenSalesforceChatWindow } from 'util/Salesforce';

export const useOpenChatWindow = () => OpenSalesforceChatWindow;
